import Vue from 'vue'
import SnackModalVue from '@/components/globals/basics/SnackModal.vue'

const SnackModalConstructor = Vue.extend(SnackModalVue)
let instance: Vue | undefined

const initInstance = () => {
  return new SnackModalConstructor({
    el: document.createElement('div'),
  })
}

export interface SnackModalOption {
  header: string
  body: string
}

const snackModal = (option: SnackModalOption): void => {
  if (!instance) {
    instance = initInstance()
  }
  instance.$slots.header = [instance.$createElement('div', option.header)]
  instance.$slots.body = [instance.$createElement('div', option.body)]
  instance.$data.showSnackModal = true
}
export default snackModal
